<template>
    <personal-info-provider v-slot="{
        campaign,
        proposal,
        contact,
        campaignFields,
        countries,
        proposalStep,
        patchProposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingProposal,
        errors,
        errorMessage
    }" style="height: 100%">
        <proposal-personal-info-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :contact="contact"
            :fields="campaignFields"
            :countries="countries"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :errors="errors"
            :error-message="errorMessage"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
        />
    </personal-info-provider>
</template>
<script>
    import ProposalPersonalInfoView from "../data-views/proposals/ProposalPersonalInfoView";
    import PersonalInfoProvider     from "../providers/proposal-steps/PersonalInfoProvider";
    export default {
        name: "ProposalPersonalInfoRouterView",
        components: {
            PersonalInfoProvider,
            ProposalPersonalInfoView,
        }
    }
</script>
